import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import InlineEdit from '@atlaskit/inline-edit';
import { ErrorMessage } from '@atlaskit/form';
import { fontSize, gridSize } from '@atlaskit/theme/constants';
import { DateTimePicker } from '@atlaskit/datetime-picker';
import { formatDate } from '../../../services/UtilsService';
import { DATE_PLACEHOLDER, TIME_PLACEHOLDER } from '../../constants/TimePlaceholderConstants';

const ReadViewContainer = styled.div`
  display: flex;
  line-height: ${(gridSize() * 2.5) / fontSize()};
  max-width: 100%;
  min-height: ${(gridSize() * 2.5) / fontSize()}em;
  padding: ${gridSize()}px 0px;
  word-break: break-word;

  color: ${props => (props.defaultValue === '' ? '#7a869a' : '#091E42')};
`;

type iState = {
  value: string;
  focused: boolean;
};
const initialState: iState = {
  value: '',
  focused: false,
};
const DivWrapper = styled.div``;
const InlineEditDateTimePicker = ({
  name,
  defaultValue,
  label,
  onConfirm,
  isRequired = false,
  testId = 'inline-edit-date-time-picker',
  timeFormat = 'HH:mm',
  dateFormat = 'Do MMMM YYYY',
  isDisabled = false,
}: {
  defaultValue?: string;
  label: string;
  name: string;
  onConfirm?: (name: string, newValue: string | null) => void;
  isRequired?: boolean;
  testId?: string;
  timeFormat?: string;
  dateFormat?: string;
  isDisabled?: boolean;
}) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState(s => ({
      ...s,
      value: defaultValue || initialState.value,
    }));
  }, [defaultValue]);
  // const handleValueChange = (newValue: string) => {
  //   setState({ ...state, value: newValue });
  // };
  // eslint-disable-next-line
  const changeValue = (value: any) => {
    const nullable = value || null;
    // if value is default value
    // don't change it
    if (value === defaultValue) {
      setState({
        ...state,
        focused: false,
      });
      return;
    }
    setState(preState => ({
      ...preState,
      value: nullable,
      focused: false,
    }));
    if (typeof onConfirm === 'function') {
      onConfirm(name, nullable);
    }
  };
  const validate = (value?: string) => {
    // isRequired
    if (isRequired && !value) {
      return 'is required';
    }
    return undefined;
  };

  return (
    <DivWrapper id={name} tabIndex={0} onFocus={() => setState(preState => ({ ...preState, focused: true }))}>
      <InlineEdit
        label={label}
        onConfirm={changeValue}
        editView={({ errorMessage, ...fieldProps }) => (
          <>
            <DateTimePicker
              // eslint-disable-next-line
              {...fieldProps}
              timeFormat={timeFormat}
              dateFormat={dateFormat}
              testId={testId}
              isDisabled={isDisabled}
              datePickerProps={{ placeholder: DATE_PLACEHOLDER }}
              timePickerProps={{ placeholder: TIME_PLACEHOLDER }}
            />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          </>
        )}
        defaultValue={state.value}
        readView={() => (
          <ReadViewContainer defaultValue={state.value}>
            {/* eslint-disable-next-line no-nested-ternary */}
            {!state.value
              ? isDisabled
                ? 'disabled'
                : 'Click to enter value'
              : formatDate(state.value, 'DD MMMM  YYYY, h:mm a')}
          </ReadViewContainer>
        )}
        isEditing={!isDisabled && state.focused}
        onEdit={() => setState({ ...state, focused: true })}
        onCancel={() => setState({ ...state, focused: false })}
        validate={validate}
      />
    </DivWrapper>
  );
};
export default InlineEditDateTimePicker;
